import React from "react";
import "animate.css";
import contentData from "../data.json";
import ElementWrapper from "./elementWrapper";

const Content: React.FC = () => {
    return (
        <div>
            {Object.keys(contentData).map((key, index) => {
                const contentKey = key as keyof typeof contentData;
                const currentContent = contentData[contentKey];

                return (
                    <ElementWrapper key={index} contentKey={contentKey} currentContent={currentContent} />
                );
            })}
        </div>
    );
};

export default Content;
